import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AlertsCard = () => {
  return (
    <Card
      sx={{
        height: '100%',
        backgroundColor: '#fff',  // white background
        border: 'none',
        borderRadius: 3,
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.05)',
        border: '1px solid #ffe0b2',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'scale(1.01)',
          boxShadow: '0 12px 20px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <WarningAmberIcon sx={{ mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Alerts
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ fontSize: '0.95rem' }}>
          • Overstock: <strong>15 items</strong><br />
          • Expiring Discounts: <strong>4</strong><br />
          • Out-of-Stock: <strong>8</strong>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default AlertsCard;